/**
 * One-time gate for the result-card "peek" hint: plays once per shopper ever,
 * latched on `animationend` (the animation only actually runs below `lg`).
 */
const PEEK_STORAGE_KEY = 'result-peek-shown'

let seen: boolean | null = null

export function hasSeenResultPeek(): boolean {
  if (seen === null) {
    try {
      seen = Boolean(window.localStorage.getItem(PEEK_STORAGE_KEY))
    } catch {
      // Storage unavailable: treat as seen so the hint can't replay every view.
      seen = true
    }
  }
  return seen
}

export function markResultPeekSeen(): void {
  seen = true
  try {
    window.localStorage.setItem(PEEK_STORAGE_KEY, '1')
  } catch {
    // Already latched in-memory for this page; nothing else to do.
  }
}
